export default {
    async createPdf(pdfOptions: object, fileName: string) {
        const {default: pdfMake} = await import('pdfmake/build/pdfmake');
        const {default: vfsFonts} = await import('pdfmake/build/vfs_fonts');
        pdfMake.vfs = vfsFonts;
        pdfMake.createPdf(pdfOptions).download(fileName);
    },
};
